<script>
import { mapActions } from 'vuex';
import NotificationCount from '../../../components/NotificationCount.vue';

export default {
    components: {
        NotificationCount
    },

    data() {
        return {
            notification_groups: [],
            showUnread: true
        }
    },

    mounted() {
        this._getNotifications();
    },

    methods: {
        ...mapActions('app', [
            'getNotifications',
            'markNotification',
        ]),

        _getNotifications() {
            const params = {
                type: 'other',
                is_read: !this.showUnread
            };

            this.getNotifications(params)
                .then(res => {
                    this.notification_groups = res.data;
                })
                .finally(() => {
                    this.$emit('count', -1);
                })
        },

        _markNotification(notification) {
            if (notification.is_read) return;

            const params = {
                type: 'other',
                id: notification.id
            };

            this.markNotification(params)
                .then(() => {
                    notification.is_read = true;
                })
                .finally(() => {
                    this.$emit('count', -1);
                })
        },

        // handlers //

        async handleClickShowUnread(bool) {
            await this.setShowUnread(bool);
            this._getNotifications();
        },

        async setShowUnread(bool) {
            this.showUnread = bool;
        },
    }
}
</script>

<template>
    <Transition name="fade">
        <div class="notifications-container">
            <div class="show-unread-ctr">
                <div class="show-unread-only-btn" :class="{ 'selected-btn': showUnread }"
                    @click="handleClickShowUnread(true)">
                    {{ $t('notifications.show_unread_only') }}
                </div>
                <div class="show-all-btn" :class="{ 'selected-btn': !showUnread }" @click="handleClickShowUnread(false)">
                    {{ $t('notifications.show_past') }}
                </div>
            </div>

            <div v-for="group in notification_groups" :key="group.id" 
                class="notification"
            >
                <div v-if="group.notifications.length === 1"
                    class="single-notification"
                >
                    <div class="notification-text" 
                        :class="{ 'marked-read-message': !showUnread }"
                        @mouseover="_markNotification(group.notifications[0])"
                    >
                        <span>{{ group.notifications[0].message }}</span>
                        <br>
                        <span style="color: gray; font-style: italic; font-size: .8em">{{ group.notifications[0].created_on | dateFormat }}</span>
                    </div>
                    <a class="sust-btn sust-btn-green redirect-btn"
                        :href="group.notifications[0].link" target="_blank"
                    >
                        {{ $t('notifications.redirect') }}
                    </a>
                </div>
                <div v-else-if="group.is_open === false" 
                    class="grouped-notification"
                >
                    <div class="flex-all-centered-row" style="justify-content: space-between;">
                        <div style="flex: 2; padding-right: .5em;">
                            {{ $t(`notifications.grouped_messages.${group.type}`) }} ({{ group.notifications.length }})
                        </div>
                        <button class="sust-btn sust-btn-green"
                            @click="() => group.is_open = true"
                            style="flex: 1; box-shadow: none !important;"
                        >
                            {{ $t('notifications.grouped_messages.show_all') }}
                        </button>
                    </div>
                </div>
                <div v-else 
                    v-for="notification in group.notifications" :key="notification.id"
                    class="single-notification"
                    @mouseover="_markNotification(notification)"
                >
                    <div class="notification-text" 
                        :class="{ 'marked-read-message': !showUnread }"
                    >
                        <span>{{ notification.message }}</span>
                        <br>
                        <span style="color: gray; font-style: italic; font-size: .8em">{{ notification.created_on | dateFormat }}</span>
                    </div>
                    <a class="sust-btn sust-btn-green redirect-btn"
                        :href="notification.link" target="_blank"
                    >
                        {{ $t('notifications.redirect') }}
                    </a>
                </div>
            </div>

            <div class="no-notifications-text" v-if="notification_groups.length == 0">
                {{ $t('notifications.nothing') }}
            </div>
        </div>
    </Transition>
</template>

<style lang='scss' scoped>
    .fade-active {
        transition: opacity .66s ease;
    }

    .fade-from,
    .fade-to {
        opacity: 1;
    }

    .notifications-container {
        background-color: whitesmoke;
        border-radius: .5em;
        border: thin solid var(--sustainfinity-navy);

        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        width: 400px;
        max-height: 400px;
        overflow-y: auto;
        overflow-x: hidden;

        > .notification {
            padding: .5em;
            width: 100%;
            border-bottom: thin solid lightgray;
            color: black;

            > .single-notification {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                
                padding: .5em;
                width: 100%;

                transition: all 150ms;
                &:hover {
                    background-color: lightgray;
                }

                > .notification-text {
                    flex: .65;
                }

                > .marked-read-message {
                    flex: 1 !important;
                    pointer-events: none !important;
                    cursor: default !important;
                }

                > .redirect-btn {
                    box-shadow: none !important;

                    &:hover {
                        color: white !important;
                    }
                }
            }
        }

        > .show-unread-ctr {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-content: center;
            align-items: center;
            width: 100%;
            border-bottom: thin solid lightgray;

            > div {
                text-align: center;
                flex: .5;
                transition: all 150ms;
                cursor: pointer;
                &:hover {
                    background-color: lightgray;
                }
            }

            > .show-unread-only-btn {
                border-right: thin solid lightgray;
            }

            > .selected-btn {
                background-color: gray;
                color: white;
            }
        }

        > .no-notifications-text {
            padding: 1em;
        }
    }

</style>